import React from "react";
import "./OrderConfermation.css";
import { Outlet } from "react-router-dom";
import OrderSummary from "../OrderSummary";
import OrderConfirmationTopBar from "../OrderConfirmationTopBar";

const OrderConfirmation = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center py-8 pt-40 mb-10">
      <div className="w-[90%] max-w-5xl bg-white p-6 rounded-2xl shadow-lg border-2 border-[#551e19]">
        <div className="-mt-11 z-10 bg-white max-w-max mx-auto px-8">
          <h1 className="text-4xl font-medium text-center text-[#551e19] mb-6">
            Checkout
          </h1>
        </div>
        <OrderConfirmationTopBar />
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mt-6">
          <div className="col-span-1 md:col-span-3">
            <Outlet />
          </div>
          <div className="col-span-1 md:col-span-2">
            <OrderSummary />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;